// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2b9aedf90eda030bcb2e","655":"e7129131ba5c2fc46fd5"}[chunkId] + ".js";
};